export const reportsConfig = {
  // Whether to enable reports
  enabled: true,
  reportTypes: [
    // Comment for better diffs
    "Broken Link",
    "Wrong Category",
    "Outdated",
    "Other",
  ],

  // Whether to require sign in to report
  requireSignIn: false,
}
